var stopsData = [
 {
   "id": 6,
   "name": "Place du Vallon",
   "lng": 6.639080865,
   "lat": 46.5266594,
   "title": "Bienvenue à Lausanne-les-Bains! L'histoire mouvementée d'un quartier les pieds dans l'eau.",
   "text1_p1": "Niché au fond de la vallée du Flon – d'où son nom – le quartier du Vallon a changé plusieurs fois de visage aux cours des siècles. Au XVIIIe siècle, c'est son heure de gloire: la haute société s'y rend pour y «prendre les eaux» dans des bains thermaux (situés à l'emplacement du n°12) alimentés par une source ferrugineuse recommandée par les médecins. Le vallon est orné d'une promenade plantée d'arbres et d'un pavillon des bains. Au tournant du XXe siècle, tout cela disparaît. Le quartier attire cependant toujours les touristes qui, de 1899 à 1948, pouvaient monter jusqu'au tout nouveau lac de Sauvabelin grâce à un funiculaire dont la gare de départ subsiste.",
   "text1_p2": "",
   "text2_p1": "Mais au début du XXe siècle, le quartier, devenu industriel, se distingue surtout par son insalubrité. Pour améliorer l'hygiène, on crée les Bains et Buanderie Haldimand, destinés cette fois à la population ouvrière qui ne dispose pas d'eau courante. Ces bains sont alimentés par une eau sans minéralisation particulière, la source ferrugineuse ayant été perdue. La construction en 1958 de l'usine d'incinération du Vallon, à 200 mètres d'ici, n'améliore de loin pas l'image du quartier. Durant ces dernières années, le Vallon a aussi accueilli divers squats et une part de la scène alternative lausannoise.",
   "text2_p2": "Aujourd'hui, l'ancienne usine d'incinération a été remplacée par celle de Tridel, laissant le quartier respirer. Cette disparition laisse de la place pour imaginer un nouvel avenir au quartier. Les habitants sont consultés et participent à la définition des projets d'aménagement... Peut-être que l'on verra un jour des bains réapparaître dans ce quartier si changeant!",
   "interaction": "A quoi ressemblaient ces bains?",
   "followtrack": "Je veux poursuivre mon chemin",
   "question_subject": "Existence des éléments du quartier par ordre croissant",
   "question": "Laquelle de ces suites correspond à la chronologie du quartier du Vallon?",
   "type_question": "single",
   "answer1": "Bains et Buanderie Haldimand, Funiculaire, Usine Tridel, Squats",
   "answer2": "Funiculaire, Bains et Buanderie Haldimand, Squats, Usine Tridel",
   "answer3": "Funiculaire, Usine Tridel, Bains et Buanderie Haldimand, Squats",
   "answer4": "Squats, Bains et Buanderie Haldimand, Funiculaire, Usine Tridel",
   "correct": 2,
   "img_title": "poste_6.jpg",
   "img_swip1": "fig_6a.jpg",
   "img_swip1_legend": "Trois différents visages du Vallon: les anciens bains thermaux",
   "img_swip2": "fig_6b.jpg",
   "img_swip2_legend": "Trois différents visages du Vallon: le funiculaire",
   "img_swip3": "fig_6c.jpg",
   "img_swip3_legend": "Trois différents visages du Vallon: les populaires bains Haldimand ",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 7,
   "name": "Tunnel de la Barre",
   "lng": 6.637391121,
   "lat": 46.52538984,
   "title": "La ceinture Pichard, ou comment défier le relief lausannois.",
   "text1_p1": "Tout cycliste s'aventurant à Lausanne sait que le relief de cette ville est tout sauf plat. C'était plus encore le cas lorsque les vallons du Flon et de la Louve n'étaient pas encore comblés et que l'éperon de la Barre constituait un obstacle difficile à franchir.",
   "text1_p2": "Pour mieux se déplacer à Lausanne, le premier ingénieur cantonal vaudois, Adrien Pichard, élabore un concept de circulation: la «ceinture Pichard». La construction de cette ceinture routière (1836-1860) neutralise en grande partie la topographie lausannoise.",
   "text2_p1": "Au nord de la ville, le tunnel de la Barre, long de 56 mètres, relie les profonds vallons du Flon et de la Louve à l’endroit où ces deux cours d’eau se rapprochent et marquent un resserrement avant de circonscrire la colline de la Cité. Le vallon du Flon est traversé grâce à la construction magistrale du Grand Pont, qui constitua longtemps l'une des principales attractions touristiques de Lausanne.",
   "text2_p2": "Au début du XXe siècle la ceinture Pichard est complétée par d'autres ouvrages comme les ponts Chauderon (1904-1905) et Bessières (1908-1910). Les conditions de circulation ainsi nettement améliorées favorisent le développement de la ville.",
   "interaction": "Une ceinture de circulation qui passe par où?",
   "followtrack": "Je veux poursuivre mon chemin",
   "question_subject": "Durée de construction de la ceinture Pichard",
   "question": "En combien de temps a été construite la ceinture Pichard? ",
   "type_question": "single",
   "answer1": "14 ans",
   "answer2": "24 ans",
   "answer3": "34 ans",
   "answer4": "54 ans",
   "correct": 2,
   "img_title": "poste_7.jpg",
   "img_swip1": "fig_7a.jpg",
   "img_swip1_legend": "Le tunnel creusé à travers la molasse de la Barre facilite grandement le passage entre la vallée du Flon et celle de la Louve.",
   "img_swip2": "",
   "img_swip2_legend": "",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 8,
   "name": "Place de la Cathédrale",
   "lng": 6.634875434,
   "lat": 46.52286296,
   "title": "Des constructions locales et durables et une matière première vivante.",
   "text1_p1": "Locales? Oui! Les matériaux de construction de la plupart des édifices de la Cité proviennent des carrières de molasse lausannoise exploitées par le passé autour du vieux bourg et des vallées du Flon et de la Louve. Durables? Oui, mais sensibles à la pluie et à la pollution. Les bâtiments en molasse nécessitent des travaux d’entretien et de restauration réguliers. Voyez-vous quelques-uns de ces blocs rongés chimiquement par l'air et l'humidité?",
   "text1_p2": "",
   "text2_p1": "La molasse, mais aussi d'autres roches comme le calcaire, utilisé par exemple pour les marches d'escalier, contiennent les restes fossiles d'animaux et de végétaux d’espèces tropicales. Ouvrez l’œil! Ces témoins sont parfois visibles sur les façades des murs de la Cité. Ils racontent une histoire climatique tropicale bien différente de celle d’aujourd’hui.",
   "text2_p2": "",
   "interaction": "Non, montrez-moi à quoi ils ressemblent!",
   "followtrack": "Amenez-moi plutôt poste suivant",
   "question_subject": "Roches présentes autour de la cathédrale",
   "question": "Parmi ces roches, laquelle ne fait pas partie du bâti présent autour de la cathédrale? ",
   "type_question": "single",
   "answer1": "Le Gneiss",
   "answer2": "La Molasse",
   "answer3": "Le Calcaire",
   "answer4": "Le Granite",
   "correct": 4,
   "img_title": "poste_8.jpg",
   "img_swip1": "fig_8a.jpg",
   "img_swip1_legend": "La molasse – une des roches utilisée pour la construction des bâtiments et des trottoirs de la Cité",
   "img_swip2": "fig_8b.jpg",
   "img_swip2_legend": "Le calcaire – une des roches utilisée pour la construction des bâtiments et des trottoirs de la Cité",
   "img_swip3": "fig_8c.jpg",
   "img_swip3_legend": "Le gneiss – une des roches utilisée pour la construction des bâtiments et des trottoirs de la Cité",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 9,
   "name": "Place de la Riponne",
   "lng": 6.633119754,
   "lat": 46.52298479,
   "title": "La valse des pelleteuses: combler et creuser le vallon de la Louve.",
   "text1_p1": "Au cours du XIXe siècle, la ville de Lausanne manque cruellement d'espace pour se développer. Les vallons de la Louve et du Flon qui, jusqu'ici, étaient utile à la défense de la ville, sont devenus un frein à son développement. Les autorités décident alors de combler les vallons pour enterrer les cours d'eau pollués et de créer des espaces publics.",
   "text1_p2": "Le voûtage du Flon permet la création de la place Pépinet et de la rue Centrale. La place de la Riponne, elle, est issue du voûtage de la Louve et du comblement de son vallon (1812-1840). A l'interface entre la ville et la campagne, la place de la Riponne abrite à cette époque le marché aux chevaux et une partie du marché artisanal.",
   "text2_p1": "Avec la création de la place de la Riponne, l’histoire du vallon de la Louve n’est cependant pas terminée. En 1976, des pelleteuses creusent la place et mettent le vallon temporairement à ciel ouvert pour permettre la construction du parking souterrain de la Riponne. Trente ans plus tard, les pelleteuses sont de retour: une partie de la place de la Riponne est de nouveau excavée dans le cadre de la construction du M2, Métro de Lausanne qui relie depuis 2008 Ouchy à Epalinges. À quand les prochains travaux?",
   "text2_p2": "",
   "interaction": "Que se passe-t-il ensuite?",
   "followtrack": "Amenez-moi au poste suivant!",
   "question_subject": "Occurence des événements ordre croissant",
   "question": "Laquelle de ces suites correspond à la chronologie de la place de la Riponne?",
   "type_question": "single",
   "answer1": "Construction du parking souterrain, Voûtage de la Louve, Construction du Palais de Rhumine, Construction de la station du M2",
   "answer2": "Voûtage de la Louve, Construction du Palais du Rhumine, Construction du parking souterrain, Construction de la station du M2",
   "answer3": "Construction du Palais du Rhumine, Construction du parking souterrain, Voûtage de la Louve, Construction de la station du M2",
   "answer4": "Voûtage de la Louve, Construction du Palais du Rhumine, Construction de la station du M2, Construction du parking souterrain, ",
   "correct": 2,
   "img_title": "poste_9.jpg",
   "img_swip1": "fig_9a.jpg",
   "img_swip1_legend": "Sur cette peinture d'époque (1842), on remarque que le Palais de Rhumine n'existe pas encore. Il a en effet été construit après le voûtage de la Louve.",
   "img_swip2": "",
   "img_swip2_legend": "",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 10,
   "name": "Louve souterraine",
   "lng": 6.632489233,
   "lat": 46.52304574,
   "title": "Découvrez l'un des cours d'eau enterré de Lausanne",
   "text1_p1": "Entre 1812 et 1840, des travaux de voûtage et de comblement ont fait disparaître la Louve du paysage urbain. Pour l'apercevoir, il faut se rendre dans le parking souterrain de la Riponne (entrée depuis la station de métro) où un regard permet de l'observer sur un petit tronçon. Selon les conditions météorologiques, vous apercevez un petit ruisseau ou un cours d'eau turbulent.",
   "text1_p2": "",
   "text2_p1": "Une station de mesure installée sur la Louve permet de visualiser son débit, c'est-à-dire la quantité d'eau qui s'écoule en une seconde en un point donné de la rivière. Le débit de la Louve est fortement influencé par les travaux d'aménagements et les effets de l'urbanisation. Par rapport à un cours d'eau similaire à l'état naturel, les pics de débit des crues de la Louve sont beaucoup plus accentués. Cet effet est dû à l'imperméabilisation des surfaces construites qui empêchent en grande partie l'infiltration des eaux de pluies. Ces dernières vont directement rejoindre le cours d'eau au lieu d'être retenues dans le sol.",
   "text2_p2": "Des travaux ont aussi été entrepris pour dériver les eaux claires de la Louve jusqu'au déversoir situé sous la Vallée de la Jeunesse. La Louve se trouve ainsi privée d'une part de son eau, ce qui réduit surtout les pics de débit. Ce que vous observez depuis le regard n'est que le résidu de la Louve qui, autrefois, traversait la ville à ciel ouvert.",
   "interaction": "Je veux voir la Louve souterraine!",
   "followtrack": "Je préfère continuer mon chemin",
   "question_subject": "Information incorrecte sur l'urbanisation, les crues",
   "question": "Laquelle de ces affirmations est incorrecte? ",
   "type_question": "single",
   "answer1": "L'urbanisation augmente l'infiltration des eaux de pluie ",
   "answer2": "L'urbanisation entraîne l'imperméabilisation des sols ",
   "answer3": "L'imperméabilisation des sols accentue les pics de débit de crue ",
   "answer4": "L'imperméabilisation des sols réduit l'infiltration des eaux de pluie ",
   "correct": 1,
   "img_title": "poste_10.jpg",
   "img_swip1": "",
   "img_swip1_legend": "",
   "img_swip2": "",
   "img_swip2_legend": "",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 11,
   "name": "Place St-Laurent",
   "lng": 6.630561433,
   "lat": 46.52237444,
   "title": "Un fragile équilibre, hérité de l'époque glaciaire, est rompu par le creusement du métro... et voilà qu'une place s'effondre!",
   "text1_p1": "Mardi 22 février 2005, grosse surprise sur le chantier du creusement du métro m2: comme dans un sablier, eau, sable et gravats s'écoulent à travers le «plafond» du tunnel et laissent à la surface un gros trou. Que s'est-il passé? Pour mieux comprendre, remontons quelque 25’000 ans en arrière...",
   "text1_p2": "",
   "text2_p1": "Aujourd'hui, la place a retrouvé sa solidité, mais le sous-sol de Lausanne réserve encore bien des surprises!",
   "text2_p2": "",
   "interaction": "Que s'est-il passé?",
   "followtrack": "Je veux poursuivre mon chemin",
   "question_subject": "Cause de l'effondrement de la place",
   "question": "L'Effondrement place st-Laurent a eu lieu parce que... ",
   "type_question": "single",
   "answer1": "Le sol de la place était construite au-dessus d'un lac souterrain ",
   "answer2": "Le sol de la place était composé de matériel meuble ",
   "answer3": "La moraine qui faisait barrage s'est effondrée ",
   "answer4": "Les travaux ont eu lieu trop près de la surface ",
   "correct": 2,
   "img_title": "poste_11.jpg",
   "img_swip1": "fig_11a.gif",
   "img_swip1_legend": "A cette époque, le glacier du Rhône recouvre une grande partie de la région. Sur sa bordure, les cailloux et rochers transportés depuis les Alpes par la glace s'entassent et créent une moraine. Cette crête de matériaux meubles joue le rôle d’un barrage. Derrière, là où se trouve aujourd'hui Saint-Laurent, un lac se forme.",
   "img_swip2": "fig_11b.gif",
   "img_swip2_legend": "Peu à peu, ce lac se remplit de sable, devient un marais, puis finit par s'assécher. Les Lausannois trouveront ce replat bien pratique pour y construire l'église Saint-Laurent, la place et tous les bâtiments qui l'entourent.",
   "img_swip3": "fig_11c.gif",
   "img_swip3_legend": "Mais les dépôts du lac et du marais ne sont pas de la pierre: ils ressemblent plutôt à du sable gorgé d'eau. Le chantier du tunnel du métro, en perçant le fond de l'ancien lac, a rompu l'équilibre. Une partie de ce qui se trouvait au-dessus s'est effondré.",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 12,
   "name": "Place Pépinet",
   "lng": 6.63242487,
   "lat": 46.5207612,
   "title": "Pouvez-vous imaginer que deux rivières se rejoignent ici, juste sous vos pieds?",
   "text1_p1": "Les rues et les bâtiments cachent aujourd'hui la nature de cet endroit. Pourtant, plusieurs indices nous permettent de reconstituer le tableau. La rue Centrale, devant vous, a été créée en comblant la vallée du Flon qui s'écoule aujourd'hui en sous-sol, dans une galerie. Observez, à gauche, comme la ligne des maisons tourne en suivant les versants de l'ancienne vallée qui descend en pente douce vers vous. La rivière continue à votre droite et passe sous les arches du Grand-Pont. Nous la retrouverons plus tard.",
   "text1_p2": "",
   "text2_p1": "Après avoir traversé la Riponne, la Louve descend la rue... de la Louve bien sûr! Elle se jette dans le Flon juste sous vos pieds, sous la place Pépinet. C'est ainsi que la colline de la Cité, avec la cathédrale, se trouvait autrefois presque entièrement entourée d'eau, comme une île au cœur de la ville. Comme partout où deux rivières se rejoignent, le lieu était très humide. La place de la Palud, toute proche, nous le rappelle: son nom veut dire «Place du Marais».",
   "text2_p2": "",
   "interaction": "Je ne vois pas très bien, où seraient ces rivières?",
   "followtrack": "Amenez-moi plutôt poste suivant",
   "question_subject": "Affirmation fausse la position des deux rivières",
   "question": "Laquelle de ces affirmations est fausse? ",
   "type_question": "single",
   "answer1": "La Louve se jette dans le Flon ",
   "answer2": "La Louve passe sous la place de l'Europe ",
   "answer3": "Le quartier du Flon doit son nom à la rivière qui passe dessous ",
   "answer4": "Place de la Palud signifie Place du Marais",
   "correct": 2,
   "img_title": "poste_12.jpg",
   "img_swip1": "fig_12a.jpg",
   "img_swip1_legend": "Une vision de ce à quoi ressemblerait la confluence entre La Louve et Le Flon",
   "img_swip2": "",
   "img_swip2_legend": "",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 13,
   "name": "Passerelle du Flon, millieu",
   "lng": 6.63045748,
   "lat": 46.52071629,
   "title": "Du ballet des marchandises aux bals des étudiants.",
   "text1_p1": "La nuit, la vie dans le quartier du Flon bat son plein. De nombreux bars et lieux de sortie nocturne caractérisent aujourd'hui cet endroit qui, autrefois, était un lieu de transit pour les marchandises.",
   "text1_p2": "",
   "text2_p1": "Depuis sa création à la fin du XIXe siècle par comblement du vallon du Flon, le quartier homonyme est très dynamique. Zone industrielle d'abord, le quartier du Flon comprend un port franc et une gare de marchandise. Les biens acheminés par la «ficelle» (l’ancien métro) reliant le Flon à la gare ferroviaire et au port d'Ouchy transitent dans les entrepôts qui fleurissent dans la zone.",
   "text2_p2": "Des activités artisanales, créatives et récréatives prennent le relais à partir de l'après-guerre, lorsque les entrepôts perdent progressivement leur fonction. Après une période plutôt tranquille durant laquelle le site se dégrade, la ville cherche à réhabiliter le quartier du Flon en adoptant le plan partiel d'affectation (PPA) en 1999. Les travaux entrepris depuis vont progressivement transformer le quartier en un site où infrastructures de transport (m1, m2, LEB), grands commerces, loisirs et administrations se côtoient et où des bâtiments anciens se mêlent aux reconstructions.",
   "interaction": "Dites m'en plus sur le passé du Flon!",
   "followtrack": "Je veux poursuivre mon chemin",
   "question_subject": "Nom du document adopté par la ville pour réhabiliter le Flon",
   "question": "Pour réhabiliter le quartier du Flon, la ville adopte en 1999 un... ",
   "type_question": "single",
   "answer1": "Plan partiel d'aménagement",
   "answer2": "Plan localisé de quartier ",
   "answer3": "Programme pour l'aménagement ",
   "answer4": "Plan partiel d'affectation",
   "correct": 4,
   "img_title": "poste_13.jpg",
   "img_swip1": "fig_13a.jpg",
   "img_swip1_legend": "Le quartier du Flon à l'époque industrielle",
   "img_swip2": "fig_13b.jpg",
   "img_swip2_legend": "Avant",
   "img_swip3": "fig_13b2.jpg",
   "img_swip3_legend": "Après",
   "img_swip4": "fig_13c.jpg",
   "img_swip4_legend": "Avant",
   "img_swip5": "fig_13c2.jpg",
   "img_swip5_legend": "Après",
   "img_swip6": "fig_13d.jpg",
   "img_swip6_legend": "Avant",
   "img_swip7": "fig_13d2.jpg",
   "img_swip7_legend": "Après",
   "img_swip8": "fig_13e.jpg",
   "img_swip8_legend": "Avant",
   "img_swip9": "fig_13e2.jpg",
   "img_swip9_legend": "Après",
   "remarque": ""
 },
 {
   "id": 14,
   "name": "Passerelle du Flon, sud",
   "lng": 6.630294002,
   "lat": 46.52033437,
   "title": "En faisant un grand virage, une route nous rappelle comment le cours des rivières a été bouleversé... il y a 25'000 ans.",
   "text1_p1": "Le Flon, caché en sous-sol, descend la rue Centrale, passe sous le Grand-Pont et arrive sur la place de l'Europe. La route principale suit tout le long le tracé du cours d'eau. Mais que se passe-t-il? Juste après les arches du pont, la route (et le Flon en dessous d'elle) tourne brusquement avant de continuer tout droit à travers le quartier du Flon. Sauriez-vous expliquer ce changement de direction?",
   "text1_p2": "",
   "text2_p1": "Normalement, lorsque la pente est forte, comme à Lausanne, les rivières s'écoulent sans détour: le Flon aurait dû prendre le même chemin que le métro, direct jusqu'à Ouchy. Quelle force l'a-t-il détourné du droit chemin? C’est le glacier du Rhône qui, il y a 25'000 ans occupait la cuvette du Léman. Le climat était alors plus froid de 8 degrés environ qu’à l’heure actuelle. Le glacier à laissé ici de côté une imposante moraine, l'actuelle colline de Montbenon que rejoint cette passerelle. Le Flon a été obligé de longer cet obstacle en direction de l'ouest. Ce n'est qu'à Vidy qu'il pourra enfin retrouver le Léman, mais ceci est une autre histoire...",
   "text2_p2": "",
   "interaction": "Quelle est l'origine de ce changement de direction?",
   "followtrack": "Je veux continuer!",
   "question_subject": "Origine de la déviation du Flon",
   "question": "Pour quelle raison l'écoulement du Flon est-il dévié de sa route vers le lac?",
   "type_question": "single",
   "answer1": "Il y a 20'000 ans, la topographie était différente et a conduit la rivière à s'écouler vers l'ouest",
   "answer2": "L'écoulement de la rivière a été dévié par la présence d'une moraine glaciaire",
   "answer3": "Lors des travaux de voûtage de la vallée du Flon, la rivière a été endiguée pour être déviée vers l'ouest",
   "answer4": "Il y a 20'000 ans, le glacier du Rhône s'arrêtait au niveau actuel du Flon, déviant l'écoulement de ce dernier",
   "correct": 2,
   "img_title": "poste_14.jpg",
   "img_swip1": "fig_14a.jpg",
   "img_swip1_legend": "Schéma de la géologie du Flon, avec la moraine de Montbenon déviant la rivière de sa route vers le lac.",
   "img_swip2": "fig_14b.jpg",
   "img_swip2_legend": "Illustation de la vallée du Flon avant son remblaiement. On y voit les deux étages d'arches que comportait le Grand Pont à l'origine.",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 },
 {
   "id": 15,
   "name": "Esplanade de Montbenon",
   "lng": 6.626473268,
   "lat": 46.51919587,
   "title": "Dans la famille des moraines de Lausanne, qui est la plus vieille? Un petit jeu pour découvrir que les glaciers ne tiennent pas longtemps en place...",
   "text1_p1": "En se déplaçant, tous les glaciers transportent d'innombrables fragments de roches arrachés au fond et aux bords des vallées ou éboulés sur la glace. Ces matériaux rocheux peuvent être plus petits qu'un grain de sable... ou aussi gros qu'une maison!",
   "text1_p2": "",
   "text2_p1": "Quand le climat est favorable – froid, humide – le glacier progresse vers l'aval, emportant avec lui de très nombreux morceaux de roche. S'il se forme autant de glace en montagne qu'il n'en fond en plaine, le glacier cesse alors de progresser: la glace continue de couler vers l'aval, mais le front du glacier reste à la même place durant plusieurs années. Les morceaux de roche, toujours transportés par la glace, s'empilent tous au même endroit dans la plaine. C'est ainsi qu'à chaque arrêt du glacier se crée à sa hauteur une moraine, comme celle de Montbenon. Mais le climat change sans cesse. Si les températures augmentent beaucoup, le glacier fond, devient plus petit et recule. S'il fait à nouveau plus froid, il refera du sur place et construira une autre moraine. S’il fait beaucoup plus froid, le glacier se remettra à grossir et son front progressera vers l’aval.",
   "text2_p2": "Allez jusqu'au bord de l'esplanade, face au lac (là où se trouvait le glacier du Rhône). Vous voyez un peu plus bas la colline de Montriond, couverte de forêt, qui dépasse des bâtiments: c'est une autre moraine! A votre avis, est-elle plus jeune ou plus vieille que celle de Montbenon?",
   "interaction": "Les glaciers forment des moraines mais comment?",
   "followtrack": "Je continue mon chemin",
   "question_subject": "Age relatif des deux moraines",
   "question": "Entre la moraine de Montenon et celle de Montriond, laquelle est la plus récente? ",
   "type_question": "single",
   "answer1": "Celle de Montriond ",
   "answer2": "Celle de Montbenon ",
   "answer3": "Il est impossible de dater des moraines glaciaires",
   "answer4": "Elles ont les deux le même âge",
   "correct": 1,
   "img_title": "poste_15.jpg",
   "img_swip1": "fig_15a.jpg",
   "img_swip1_legend": "En reculant en direction du lac, le glacier a déposé la moraine de Montbenon, puis la moraine de Montriond.",
   "img_swip2": "",
   "img_swip2_legend": "",
   "img_swip3": "",
   "img_swip3_legend": "",
   "img_swip4": "",
   "img_swip4_legend": "",
   "img_swip5": "",
   "img_swip5_legend": "",
   "img_swip6": "",
   "img_swip6_legend": "",
   "img_swip7": "",
   "img_swip7_legend": "",
   "img_swip8": "",
   "img_swip8_legend": "",
   "img_swip9": "",
   "img_swip9_legend": "",
   "remarque": ""
 }
]

export default stopsData;



// WEBPACK FOOTER //
// ./src/data/stops_content_min.js